import React from 'react';
import {Typography, TypographyProps} from '@mui/material';
import {FONTS} from "../../constants/theme";

interface ThemedTextProps extends TypographyProps {
  text: string;
  variant?: TypographyProps['variant'];
  align?: TypographyProps['align'];
  color?: TypographyProps['color'];
  gutterBottom?: boolean;
  component?: React.ElementType;
  noWrap?: boolean;
  display?: TypographyProps['display'];
  sx?: TypographyProps['sx'];
  fontWeight?: string | number;
  fontSize?: string;
  lineHeight?: string;
  fontFamily?: string;
  letterSpacing?: string | number;
}

const ThemedText = ({
                      text,
                      variant = 'body1',
                      align = 'inherit',
                      color = 'text.primary',
                      gutterBottom = false,
                      component = 'span',
                      noWrap = false,
                      display = 'initial',
                      sx = {},
                      fontWeight = '300',
                      fontSize = '18px',
                      lineHeight = '1.5',
                      fontFamily = FONTS.MONTSERRAT,
                      letterSpacing = '0px',
                    }: ThemedTextProps) => {
  const formatText = (text: string) => {
    if (!text) return text;
    return text.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line.split(/(\*\*.*?\*\*)/g).map((part, i) =>
          part.startsWith('**') && part.endsWith('**') ? (
            <b key={i}>{part.slice(2, -2)}</b>
          ) : (
            part
          )
        )}
        <br/>
      </React.Fragment>
    ));
  };

  return (
    <Typography
      variant={variant}
      align={align}
      color={color}
      gutterBottom={gutterBottom}
      component={component}
      noWrap={noWrap}
      display={display}
      sx={{
        color: color,
        fontFamily: fontFamily,
        fontWeight: fontWeight,
        fontSize: fontSize,
        lineHeight: lineHeight,
        letterSpacing: letterSpacing,
        ...sx,
      }}
    >
      {formatText(text)}
    </Typography>
  );
};

export default ThemedText;
